kv.controller('InventoryItemRepairHistoryCtrl', function ($uibModalInstance, data, $injector, $scope) {
    let vm = new modalCtrl($uibModalInstance, $injector, 'inventory_item', 'inventory_item_id', $scope, data);

    vm.data ={};
    vm.data.repair_history = {};
    vm.data.repair_history = {
        repair_date: moment().format('YYYY-MM-DD'),
    };

    if(data.repair_id != -1) {
        vm.rest.get({
            url: 'inventory_item/' + data.inventory_id + '/repair/actions/get_repair_history?repair_id=' + data.repair_id,
        }).then(function (res) {
            vm.data.repair_history = res.data;
        });
    }

   // vm.data.repair_history.repair_date = moment().format('YYYY-MM-DD');

    vm.save = function () {
        let errors = {};
        if (!vm.clientSideValidate(errors, 'data', $('.modal-content'))) return;
        vm.confirm(vm.trans("LANG.CONFIRM_MOVE"), vm.trans("LANG.CONFIRM_REPAIR_HISTORY")).then(response => {
            if (response !== "ok") return;
            let postData = angular.copy(vm.data);
            if(data.repair_id != -1) {
                postData.event = 'edit_repair_history';
            } else {
                postData.event = 'add_repair_history';
            }

            vm.rest.update({
                url: 'inventory_item/' + data.inventory_id + '/repair/actions/' + postData.event,
                data: postData,
                success: function () {
                    vm.close('ok');
                }
            });
        });
    };

    return vm;
});
